export default "__VITE_ASSET__f4de0136__"